import { AboutLayout as MobileAbout } from '@/components/mo/About';
import { AboutLayout as PcAbout } from '@/components/pc/About';
import { useIsMobile } from '@/hooks/useIsMobile';
import { Spin } from 'antd';
import styled from 'styled-components';

const AdjusterIntroPage = () => {
  const isMobile = useIsMobile();

  if (isMobile === null) {
    return (
      <SpinnerWrapper>
        <Spin size="large" />
      </SpinnerWrapper>
    );
  }

  return isMobile ? <MobileAbout /> : <PcAbout />;
};

export default AdjusterIntroPage;

const SpinnerWrapper = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
